import { IProductForm } from 'src/types'

export const intialProductValues = (code: string): IProductForm => ({
  name: '',
  description: '',
  product_type: '',
  code: code,
  gtin: null,
  image: {
    icon: null,
    file: null,
  },
  image_small: null,
  image_medium: null,
  media: [],
  selectedJourney: null,
  selectedImpacts: [],
})
